/// <reference path="../../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IdPUser } from '../models/idpuser';
import { IdentityService } from '../services/identity.service';
import { FindIdPUser } from '../models/find_idpuser';
import { IdPUserRequest } from '../models/idpuser_request';
import { Alert } from '../shared/alert';
import { User } from '../models/user';
import { AppTitle } from '../shared/title';
import { AppValidators, controlErrors } from '../shared/app.validators';
import { trimReturnKey } from '../shared/strings';
import { Account } from '../services/account.service';
import { FindIdP } from '../models/find_idp';
import { IdP } from '../models/idp';
import { Subscription } from 'rxjs';

@Component({
	selector: 'add-identity-user',
	template: `
        <div class="row" [hidden]="msgHead.msg == ''">
            <div class="col-lg-6 col-md-8 col-xs-12">
                <alert [alert]="msgHead"></alert>
            </div>
        </div>
        <div class="row">
		    <div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px;">
                <form [formGroup]="form" novalid>
                    <div class="row">
									<div class="col-lg-3 col-md-6 col-xs-12">
										<div class="form-group">
											<p class="custom-label">Identity Provider*</p>
											<select [(ngModel)]="idpIdValue" formControlName="idp" class="form-control" title="Identity Provider" placeholder="Select IdP">
												<option [ngValue]="0">Select Identity Provider</option>
												<option *ngFor="let idp of idP; let i = index" [value]="idp.id">{{idp.name}}</option>
											</select>
										</div>
										<div class="form-group">
											<p class="custom-label">Username</p>
											<input type="text" formControlName="userName" class="form-control" placeholder="Username">
										</div>
										<div class="form-group">
                                <p class="custom-label">First Name</p>
                                <input type="text" formControlName="firstName" class="form-control" placeholder="First Name">
                            	</div>
										<div class="form-group">
											<p class="custom-label">Last Name</p>
											<input type="text" formControlName="lastName" class="form-control" placeholder="Last Name">
										</div>
										<div class="form-group">
											<p class="custom-label">Card ID</p>
											<input type="text" formControlName="cardId" class="form-control" placeholder="Card ID">
								  		</div>
										<div class="form-group">
											<p class="custom-label">Phone Number</p>
											<input type="text" formControlName="phoneNumber" class="form-control" placeholder="Phone Number">
										</div>
										<div class="form-group">
											<p class="custom-label">Group Names (Comma Separated)</p>
											<input type="text" formControlName="groupNames" class="form-control" placeholder="Group Names">
										</div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <button type="button" class="btn btn-large btn-primary" (click)="save()">Save</button>
					 <a style="margin-left:10px;cursor: pointer;" *ngIf="!editMode" (click)="clearForm()">Clear Form</a>
					 <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>
        </div>
        <div class="row" [hidden]="msg.msg == ''">
            <div class="col-lg-6 col-md-8 col-xs-12">
                <alert [alert]="msg"></alert>
            </div>
        </div>
    `
})

export class IdPUserComponent implements OnInit {
	hasAccess: boolean;
	msg: Alert;
	msgHead: Alert;
	data: IdPUser;
	acctNumber: string;
	user: User;
	form: FormGroup;
	idParam: string;
	editMode: boolean;
	saveCount: number;
	idpIdParam:string;
	idpIdValue:number;
	idP:IdP[];
	username: string;
	idpName: string;
	private subscriptionQueryParams: Subscription;

	constructor(private account: Account, private router: Router, private svc: IdentityService, fb: FormBuilder, private title: AppTitle, private activatedRoute: ActivatedRoute) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		this.data = new IdPUser();
		this.idP = [];
		this.idpIdValue = 0;
		this.form = fb.group({
			idp:['', Validators.compose([Validators.required])],
			userName: ['',Validators.compose([Validators.required, AppValidators.email])],
			firstName: ['', Validators.compose([Validators.maxLength(25)])],
			lastName: ['', Validators.compose([Validators.maxLength(25)])],
			cardId: ['', Validators.compose([Validators.maxLength(26)])],
			phoneNumber: [''],
			groupNames: ['', Validators.maxLength(50)],
		});
		this.editMode = false;
		this.saveCount = 1;
		this.subscriptionQueryParams = activatedRoute.queryParams.subscribe(
			(params) => {
				this.idpName = decodeURIComponent(params['idpName'])
				this.username = decodeURIComponent(params['username'])
			}
		);
	}

	ngOnInit() {
		let titleStr = 'Add New';
		let action = 'add';
		this.title.setTitles({
			title: 'Add New - IdP User',
			dashboard: 'Add New - IdP User',
		});

		this.acctNumber = this.activatedRoute.snapshot.params['acctnumber'];
		this.idParam = this.activatedRoute.snapshot.params['userId'];
		this.idpIdParam = this.activatedRoute.snapshot.params['idpid'];
		if (this.acctNumber != null) {
			this.svc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.svc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				});
		}
		this.user = this.account.getUser();
		this.loadIdP();
		if (this.idParam) {
			this.editMode = true;
			this.loadData();
			if(this.idpIdParam){
				this.idpIdValue = parseInt(this.idpIdParam);
			}
			this.title.setTitles({
				title: 'Edit - IdP User',
				dashboard: 'Edit - IdP User',
			});
			titleStr = 'Edit';
			action = 'edit';
		}
		if (this.editMode) {
			this.title.setBreadcrumbs([
				{ title: 'IdP Users', link: `idp/${this.acctNumber}/idp-users/users` },
				{ title: this.idpName + ' ', link: `` },
				{ title: this.username + ' ', link: `` },
				{ title: titleStr, link: '' },
			]);
		} else {
			this.title.setBreadcrumbs([
				{ title: 'IdP Users', link: `idp/${this.acctNumber}/idp-users/users` },
				{ title: titleStr, link: '' },
			]);
		}
	}

	goBack() {
		this.router.navigate([`idp/${this.acctNumber}/idp-users/users`]);
	}

	loadData() {
		let find = new FindIdPUser();
		find.userId = this.idParam;
		this.svc.findIdPUserApi(this.acctNumber, find).subscribe((rows: IdPUser[]) => {
			this.msg.close();
			this.data = rows[0];
			this.form.get('idp').setValue(this.data.idpId);
			this.form.get('firstName').setValue(this.data.firstName);
			this.form.get('lastName').setValue(this.data.lastName);
			this.form.get('cardId').setValue(this.data.cardId);
			this.form.get('userName').setValue(this.data.username);
			this.form.get('phoneNumber').setValue(this.data.phoneNumber);
			this.form.get('groupNames').setValue(this.data.groupNames);

		}, err => {
			console.log(err);
			if (this.svc.isErrNotFound(err)) {
				this.msg.warning(this.svc.getUserError(err));
			} else {
				if (this.svc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msg.error(this.svc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.svc.getUserErrorDefault(err));
				}
			}
		});
	}

	loadIdP() {
		this.idP = [];
		this.svc.findIdPApi(this.acctNumber, new FindIdP())
		  .subscribe((idps: IdP[]) => {
			for (let r of idps) {
				this.idP.push(r);
			}
		  }, err => {
			 console.log(err);
			 if (this.svc.isErrNotFound(err)) {
				this.msg.warning(this.svc.getUserError(err));
			 } else {
				if (this.svc.isErrUnauthorized(err)) {
				  this.hasAccess = false;
				  this.msg.error(this.svc.getUserErrorDefault(err));
				} else {
				  this.msg.error(this.svc.getUserErrorDefault(err));
				}
			 }
		  });
	 }

	viewToRequest(r: IdPUser): IdPUserRequest {
		let ret = new IdPUserRequest();
		ret.idpId = this.idpIdValue;
		ret.firstName = trimReturnKey(r.firstName);
		ret.lastName = trimReturnKey(r.lastName);
		ret.cardId = trimReturnKey(r.cardId);
		ret.phoneNumber = trimReturnKey(r.phoneNumber);
		ret.groupNames = trimReturnKey(r.groupNames);
		ret.username = trimReturnKey(r.username);
		return ret;
	}

	save() {
		if(this.idpIdValue == 0){
			this.form.get('idp').setErrors({'required': true});
			this.displayErrors(this.form);
			return;
		}
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}
		this.idpIdValue = parseInt(this.form.get('idp').value);
		this.data.idpId = this.idpIdValue;
		this.data.firstName = this.form.get('firstName').value;
		this.data.lastName = this.form.get('lastName').value;
		this.data.cardId = this.form.get('cardId').value;
		this.data.phoneNumber = this.form.get('phoneNumber').value;
		this.data.groupNames = this.form.get('groupNames').value;
		this.data.username = this.form.get('userName').value;

		if (this.editMode) {
			this.svc.updateIdPUsersApi(this.acctNumber, this.data.id, this.viewToRequest(this.data))
				.subscribe(res => {
					let saveMessage = this.svc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
					setTimeout(() => {
						this.goBack();
					}, 1000)
				}, err => {
					console.log(err);
					let e = this.svc.getUserErrorDefault(err);
					this.msg.error(e);
				});

		} else {
			this.svc.addIdPUsersApi(this.acctNumber, this.viewToRequest(this.data))
				.subscribe(res => {
					let saveMessage = this.svc.getDefaultSaveMessage();
					if (this.saveCount > 1) {
						saveMessage += ` (${this.saveCount})`
					}
					this.saveCount++;
					this.msg.success(saveMessage);
				}, err => {
					console.log(err);
					let e = this.svc.getUserErrorDefault(err);
					this.msg.error(e);
				});
		}
	}

	clearForm() {
		this.form.reset({
			firstName: '',
			lastName: '',
			middleName: '',
			badgeTypeId: '',
			field1: '',
			field2: '',
			field3: '',
			field4: '',
			field5: '',
			field6: '',
			field7: '',
			recordIdentifier: '',
			schoolGroupID: 1,
		});
	}

	displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}


}
